import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagJM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M40.22 5.168A24.887 24.887 0 0 0 25 0 24.888 24.888 0 0 0 9.78 5.168L25 20.388l15.22-15.22Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M5.168 9.78A24.889 24.889 0 0 0 0 25a24.889 24.889 0 0 0 5.168 15.22L20.388 25 5.168 9.78Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M9.78 44.832A24.888 24.888 0 0 0 25 50a24.888 24.888 0 0 0 15.22-5.168L25 29.612 9.78 44.831Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M44.832 40.22A24.887 24.887 0 0 0 50 25a24.887 24.887 0 0 0-5.168-15.22L29.612 25l15.22 15.22Z"
}));
FlagJM.displayName = 'FlagJM';
export default withFlagWrapper(FlagJM);
//# sourceMappingURL=index.js.map